"use client";

import { getSettingAdyenEUPaymentMethodsIcons } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingAdyenEUPaymentMethodsIcons";
import { getSettingUseAdyenForRetailerPayments } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingUseAdyenForRetailerPayments";
import { useIsLoggedInRetailer } from "@faire/marketplace-lib/serialized-data/isLoggedInRetailer";
import { useNationality } from "@faire/marketplace-lib/stores/retailer/useNationality";
import { useLocalization } from "@faire/web/common/localization/useLocalization";
import * as React from "react";

import { FooterBase } from "./__internal__/FooterBase";
import { FooterCTA } from "./__internal__/FooterCTA";
import { useCtaVariants } from "./__internal__/useCtaVariants";

interface IProps {
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
  noTopBorder?: boolean;
}

export const Footer: React.FC<IProps> = (props) => {
  const { noTopBorder, className } = props;

  const {
    intl: { locale },
  } = useLocalization();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { retailerCountry } = useNationality();

  const ctaProps = useCtaVariants(false, false);
  if (!ctaProps) {
    return null;
  }
  const { title, ctaContent } = ctaProps;

  return (
    <FooterBase
      className={className}
      noTopBorder={noTopBorder}
      locale={locale}
      isLoggedInRetailer={isLoggedInRetailer}
      retailerOrSessionCountry={retailerCountry}
      adyenEUPaymentMethodsIcons={
        getSettingUseAdyenForRetailerPayments()
          ? getSettingAdyenEUPaymentMethodsIcons()
          : null
      }
    >
      <FooterCTA title={title} ctaContent={ctaContent} />
    </FooterBase>
  );
};
